import React from 'react';
import "./main.css";
import CarauselImage1 from '../../images/Our-Work/1.png';
import CarauselImage2 from '../../images/Our-Work/2.png';
import CarauselImage3 from '../../images/Our-Work/3.png';
import { Navigation, A11y, Zoom } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/navigation';

export default function Ourwork() {
  return (
    <>
      <div className="work">
        <div className="our-footer"></div>
        <div className="our-robot-large"></div>
        <div className="our-robot-middle"></div>
        <div className="our-work">
          <div className="header">
            <h1>Наши работы</h1>
          </div>
          <Swiper
            className="carausel"
            modules={[Navigation, A11y, Zoom]}
            spaceBetween={55}
            slidesPerView={3}
            navigation={true}
            zoom={true}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}>
            <SwiperSlide className="carausel-box">
              <div className="carausel-box-image">
                <img src={CarauselImage1} alt="error" />
              </div>
              <div className="carausel-box-title">
                <h4>Остекление балкона</h4>
              </div>
              <div className="carausel-box-sum">
                <p>Итоговая стоимость:</p>
                <p className='bold'>38 900 руб</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className="carausel-box">
              <div className="carausel-box-image">
                <img src={CarauselImage2} alt="error" />
              </div>
              <div className="carausel-box-title">
                <h4>Остекление коттеджа</h4>
              </div>
              <div className="carausel-box-sum">
                <p>Итоговая стоимость:</p>
                <p className='bold'>54 900 руб</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className="carausel-box">
              <div className="carausel-box-image">
                <img src={CarauselImage3} alt="error" />
              </div>
              <div className="carausel-box-title">
                <h4>Остекление балкона</h4>
              </div>
              <div className="carausel-box-sum">
                <p>Итоговая стоимость:</p>
                <p className='bold'>38 900 руб</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className="carausel-box">
              <div className="carausel-box-image">
                <img src={CarauselImage3} alt="error" />
              </div>
              <div className="carausel-box-title">
                <h4>Остекление балкона</h4>
              </div>
              <div className="carausel-box-sum">
                <p>Итоговая стоимость:</p>
                <p lassName='bold'>38 900 руб</p>
              </div>
            </SwiperSlide>
            <SwiperSlide className="carausel-box">
              <div className="carausel-box-image">
                <img src={CarauselImage3} alt="error" />
              </div>
              <div className="carausel-box-title">
                <h4>Остекление балкона</h4>
              </div>
              <div className="carausel-box-sum">
                <p>Итоговая стоимость:</p>
                <p>38 900 руб</p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  )
}
